import { renderIcon } from '@opallabs/kuiper'
import { testFeature } from '@opallabs/principles'
import { colors } from '@opallabs/spectrum'

const renderMomentIcon = (storyColor) =>
  renderIcon('moment', {
    ariaMode: 'hidden',
    style: { height: 16, width: 16, color: storyColor || colors.n5.base },
  })

export const buildContextMenuOptions = ({
  callbacks,
  isExpanded,
  isInStories,
  moment,
  onContextMenuRename,
  storyId,
}) => {
  const primaryBrandSlug = moment?.brand?.slug || moment?.primaryBrand?.slug
  const momentUrl = `${window.location.origin}/moments/${primaryBrandSlug}/${moment.id}`

  const boardsOptionGroup = {
    options: [
      {
        isSelected: false,
        text: 'Add to Board',
        callback: () => {
          callbacks.onAddToBoard({ moment, defualtUnschedule: false })
        },
      },
      {
        isSelected: false,
        text: 'Unschedule',
        callback: () => {
          callbacks.onAddToBoard({ moment, defualtUnschedule: true })
        },
      },
    ],
  }

  const menuOptions = {
    header: {
      icon: renderMomentIcon(moment.primaryStory && moment.primaryStory.color),
      text: moment.name,
    },
    meta: {
      menuRowCount: 10,
    },
    optionGroups: [
      {
        options: [
          {
            isSelected: false,
            text: 'Open Moment in New Tab',
            callback: () => {
              window.open(momentUrl, '_blank')
            },
          },
          {
            isSelected: false,
            text: 'Copy Link to Moment',
            callback: () => {
              try {
                window.navigator.clipboard.writeText(momentUrl)
              } catch (ex) {
                console.error('Unable to place URL into clipboard.', ex.message)
              }
            },
          },
        ],
      },
      {
        options: [
          {
            isSelected: false,
            text: 'Rename Moment',
            callback: (track) => {
              onContextMenuRename()
              track('click', {
                action: 'rename moment',
                id: moment.id,
                isExpanded,
              })
            },
          },
          {
            isSelected: false,
            callback: (track) => {
              callbacks.duplicateMoment(moment.id)
              const postIds = moment.posts
                ? moment.posts.map((post) => post.id).join(',')
                : ''
              track('click', {
                action: 'duplicate moment',
                id: moment.id,
                isExpanded,
                postIds,
              })
            },
            text: 'Duplicate Moment',
          },
          {
            disabled: !moment.postCount,
            isSelected: false,
            callback: (track) => {
              callbacks.pickMomentCoverAsset(moment)
              track('click', {
                action: 'change moment cover image',
                id: moment.id,
                isExpanded,
              })
            },
            text: 'Choose Cover Image',
          },
        ],
      },
      {
        header: {
          text: 'Time of Day',
        },
        options: [
          {
            disabled: !moment.day_segment,
            isSelected: false,
            text: 'No Associated Time of Day',
            callback: (track) => {
              callbacks.changeDaySegment(moment.id, null)
              track('click', {
                action: 'change moment day segment',
                id: moment.id,
                isExpanded,
              })
            },
          },
          {
            disabled: moment.day_segment === 'morning',
            isSelected: false,
            text: 'Morning',
            callback: (track) => {
              callbacks.changeDaySegment(moment.id, 'morning')
              track('click', {
                action: 'change moment day segment',
                id: moment.id,
                isExpanded,
              })
            },
          },
          {
            disabled: moment.day_segment === 'afternoon',
            isSelected: false,
            text: 'Afternoon',
            callback: (track) => {
              callbacks.changeDaySegment(moment.id, 'afternoon')
              track('click', {
                action: 'change moment day segment',
                id: moment.id,
                isExpanded,
              })
            },
          },
          {
            disabled: moment.day_segment === 'evening',
            isSelected: false,
            text: 'Evening',
            callback: (track) => {
              callbacks.changeDaySegment(moment.id, 'evening')
              track('click', {
                action: 'change moment day segment',
                id: moment.id,
                isExpanded,
              })
            },
          },
          {
            disabled: moment.day_segment === 'night',
            isSelected: false,
            text: 'Night',
            callback: (track) => {
              callbacks.changeDaySegment(moment.id, 'night')
              track('click', {
                action: 'change moment day segment',
                id: moment.id,
                isExpanded,
              })
            },
          },
        ],
      },
      {
        options: [
          {
            danger: true,
            isSelected: false,
            callback: (track) => {
              callbacks.deleteMoment(moment.id, !!moment.postCount)
              track('click', {
                action: 'delete moment',
                isExpanded,
                isInStories,
                id: moment.id,
                storyId,
              })
            },
            text: 'Delete Moment',
          },
        ],
      },
    ],
  }

  if (testFeature('boards_view')) {
    menuOptions.optionGroups.splice(2, 0, boardsOptionGroup)
  }

  return menuOptions
}
